import type { FC } from "react";

import { LinkProvider } from "../../../components/WithLink/src/LinkProvider";
import TrackProvider from "../../../components/WithTrack/src/TrackProvider";
import TranslationProvider from "../../../components/WithTranslation/src/TranslationProvider";

const AllContexts: FC<any> = ({ translate, track, linkFn, children }) => (
    <TranslationProvider translate={translate}>
        <TrackProvider track={track}>
            <LinkProvider linkFn={linkFn}>{children}</LinkProvider>
        </TrackProvider>
    </TranslationProvider>
);
AllContexts.displayName = "AllContexts";
export default AllContexts;
